riot.tag2('bing-map', '<div class="map-container"> </div> <div class="pin-icon"> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="36"> <path d="M14.8,0C6.6,0.1,0,6.8,0,15c0,0.1,0,0.2,0,0.4C0.1,19,1.6,22.4,4.2,25L15,35.9L25.8,25c2.5-2.5,4.1-6,4.2-9.6 c0-0.1,0-0.3,0-0.4C30,6.7,23.2-0.1,14.8,0z"></path> </svg> </div>', '', '', function(opts) {
    this.mixin('bus');

    var BingMap = require('../../core/map/BingMap.js');
    var mapConstants = require('../../core/constants.js').map;
    var trackingJSON = require('../../data/tracking-data');

    var self = this;
    var currentSelectedDealer;
    var dealers = self.opts.points;
    var icons = {};
    var resizeTimeout;
    var origin;
    var infoboxDealerProps = self.labels.mapInfoboxDealerProps ?
      self.labels.mapInfoboxDealerProps.split(',') : [];
    var infoboxLabels = self.labels.mapInfoboxLabels ?
      self.labels.mapInfoboxLabels.split(',') : [];
    var selectBehavior = 'select';

    function mapReady() {
      return self.map && self.map.isLoaded() && self.map.isCreated();
    }

    function resetOrigin() {
      if (mapReady()) {
        self.map.resetOrigin();
      }
    }

    function setOrigin(data) {
      if (mapReady()) {
        self.map.setOrigin(data);
      }
    }

    function attachSearchArea() {
      if (mapReady()) {
        var $searchAreaBtn;
        var customOverlay;
        var jsonData = JSON.parse(JSON.stringify(trackingJSON.searchSelectedArea));
        const parentClass = 'search-area';

        $searchAreaBtn = document.createElement('button');

        jsonData.dynamic_variables[0].search += self.labels.searchArea;

        $searchAreaBtn.onclick = function(){
          var $locator = self.root;
          var mapContainer = $locator.querySelector('.map-container');
          window.scrollTo($locator.offsetTop, 0);

          self.bus.trigger(self.bus.EVENTS.DEALERS.SEARCH, {
            lat: self.map.map.getBounds().center.latitude,
            long: self.map.map.getBounds().center.longitude,
            maxResults: parseInt(self.labels.zipCodeMaxResults, 10) || Infinity
          });

          if (window.Acr.TrackingManager) {
            window.Acr.TrackingManager.clickActivity(jsonData);
          }

          if (mapContainer.classList.contains('fixed')) {
            mapContainer.classList.remove('fixed');
          }

          if (mapContainer.classList.contains('fixed-bottom')) {
            mapContainer.classList.remove('fixed-bottom');
          }
        };

        $searchAreaBtn.classList.add('search-area-button');
        $searchAreaBtn.classList.add('acr-caption-10');
        $searchAreaBtn.innerHTML = self.labels.searchArea;
        customOverlay = self.map.setCustomOverlay($searchAreaBtn, parentClass);
        self.map.map.layers.insert(customOverlay);
      }
    }

    function setInfobox(point, index) {
      var infoboxContent = "<div class=\"dealer-infobox\">"
                          + "<a class=\"dealer-infobox__close js-infobox-close\" type=\"button\">"
                          + "<i class=\"dl-icon-close\"></i></a>"
                          + "<div class=\"dealer-infobox__title acr-secondary-title-5\">{Name}</div>"
                          + "<div class=\"dealer-infobox__detail acr-paragraph-5\">{DrivingDistanceMiles} {milesText}</div>"
                          + "<a class=\"dealer-infobox__link {mapInfoboxLinkClasses} js-infobox-details\" index=\""+index+"\"><span>{mapInfoboxLinkText}</a></span></div>";

        infoboxDealerProps.forEach(function(prop) {
          infoboxContent =
            infoboxContent.replace('{' + prop + '}', point[prop]);
        });

        infoboxLabels.forEach(function(label) {

          infoboxContent =
            infoboxContent.replace('{' + label + '}', self.labels[label]);
        });
        self.map.setInfobox(point, infoboxContent);

        self.root.querySelector('.js-infobox-close').onclick = closeInfoBox;

        if (self.opts.isEmbeddedInRaq) {
          self.root.querySelector('.js-infobox-details').onclick = selectDealerInfoBox;
        } else {
          self.root.querySelector('.js-infobox-details').onclick = viewDetails;
        }
    }

    function closeInfoBox() {
      self.map.closeInfobox();
    }

    function viewDetails(event) {
      self.bus.trigger(self.bus.EVENTS.DEALERS.OPEN_DETAIL,
        {
          index: event.currentTarget.getAttribute('index')
        }
      );
    }

    function selectDealerInfoBox(event) {
      var dealerInfo;

      dealerInfo = self.map.points.filter(function (dealer) {
        return dealer.selected;
      });
      self.bus.trigger(self.bus.EVENTS.DEALERS.CTA_CLICK,
        {
          type: selectBehavior,
          parameters: [{'zipcode': dealerInfo[0].ZipCode, 'dealerid': dealerInfo[0].DealerNumber}],
        }
      );
    }

    function updatePins(data) {
      var zoom;

      dealers = data.points;

      if (self.opts.selectZoomLevel && !self.onDetailView) {
        zoom = parseInt(self.opts.selectZoomLevel, 10);
      }

      if (data.points) {
        self.map.clear();
        self.map.updatePins(data.points, zoom, icons);
      }

      self.bus.trigger(self.bus.EVENTS.MAP.READY);

      self.update();
    }

    function selectDealer(data, type) {
      if (!mapReady()) {
        return;
      }

      var index = data && data.index !== undefined ? data.index : 0;
      var points = data ? [dealers[index]] : dealers;
      var bestview = self.map.getBestView(points);
      var options = {
        center: bestview.center
      };

      if (data && data.index !== undefined) {
        currentSelectedDealer = data.index;
        dealers[data.index].selected = true;
        setInfobox(dealers[data.index], data.index);
      } else if (currentSelectedDealer !== undefined) {

        dealers[currentSelectedDealer].selected = false;
      }

      updatePins({
        points: dealers
      });

      if (self.opts.selectZoomLevel && type !== 'close') {
        if(window.innerWidth >= mapConstants.MOBILE_BREAKPOINT) {
          options.zoom = parseInt(self.opts.selectZoomLevel, 10);
        }
      } else {
        options.bounds = bestview;
      }

      self.map.setView(options);
    }

    function resize() {
      var mapContainer, bestview, options;

      if (dealers !== undefined && dealers > 0){
        bestview = self.map.getBestView(dealers);
        options = {
          center: bestview.center
        };
      }

      if (window.innerWidth <= mapConstants.MOBILE_BREAKPOINT) {
        mapContainer = self.root.querySelector('.map-container');

        if (mapContainer.classList.contains('fixed')) {
          mapContainer.classList.remove('fixed');
        }
      }

      if (currentSelectedDealer >= 0 && window.innerWidth >= mapConstants.MOBILE_BREAKPOINT) {
        options.zoom = parseInt(self.opts.selectZoomLevel, 10);
        options.center.latitude = dealers[currentSelectedDealer].Latitude;
        options.center.longitude = dealers[currentSelectedDealer].Longitude
        self.map.closeInfobox();
        self.map.setView(options);
      } else if (currentSelectedDealer >= 0 && window.innerWidth <= mapConstants.MOBILE_BREAKPOINT) {
        options.bounds = bestview;
        options.center.latitude = dealers[currentSelectedDealer].Latitude;
        options.center.longitude = dealers[currentSelectedDealer].Longitude
        self.map.closeInfobox();
        self.map.setView(options);
      }

    }

    function debouncedResize() {
      window.clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(resize, 250);
    }

    this.on('mount', function () {
      var mapContainer = self.root.querySelector('.map-container');
      var icon = self.root.querySelector('.pin-icon');
      var infoboxTemplate;
      var defaultIcon;
      var hoverIcon;
      var selectedIcon;
      var preferredIcon;
      var defaultPinColor;
      var hoverPinColor;
      var selectedPinColor;
      var preferredPinColor;

      if (self.mapInfobox) {
        infoboxTemplate = self.mapInfobox;
      }

      if (self.labels.mapPinContent || self.labels.mapPinImage) {
        if (self.labels.mapPinContent) {
          icon.innerHTML = self.labels.mapPinContent;
          defaultPinColor = self.labels.mapPinColorDefault;
          hoverPinColor = self.labels.mapPinColorHover;
          preferredPinColor = self.labels.mapPinColorPreferred;
          selectedPinColor = self.labels.mapPinColorSelected;
        } else {
          icons.iconImage = self.labels.mapPinImage;
        }

        icons.anchorX = parseInt(self.labels.mapPinAnchorX);
        icons.anchorY = parseInt(self.labels.mapPinAnchorY);
        icons.textOffsetX = parseInt(self.labels.mapPinTextOffsetX);
        icons.textOffsetY = parseInt(self.labels.mapPinTextOffsetY);
      } else {
        defaultPinColor = mapConstants.PIN_COLORS.DEFAULT;
        preferredPinColor = mapConstants.PIN_COLORS.PREFERRED;
        selectedPinColor = mapConstants.PIN_COLORS.SELECTED;

        icons.anchorX = mapConstants.PIN_ANCHOR.x;
        icons.anchorY = mapConstants.PIN_ANCHOR.y;
        icons.textOffsetX = mapConstants.PIN_TEXT_OFFSET.x;
        icons.textOffsetY = mapConstants.PIN_TEXT_OFFSET.y;
      }

      if (!icons.iconImage) {
        defaultIcon = icon.cloneNode(true);
        preferredIcon = icon.cloneNode(true);
        selectedIcon = icon.cloneNode(true);

        defaultIcon.querySelector('path').setAttribute(
          'fill', defaultPinColor);
        preferredIcon.querySelector('path').setAttribute(
          'fill', preferredPinColor);
        selectedIcon.querySelector('path').setAttribute(
          'fill', selectedPinColor);

        icons.DEFAULT = defaultIcon.innerHTML;
        icons.PREFERRED = preferredIcon.innerHTML;
        icons.SELECTED = selectedIcon.innerHTML;

        if (hoverPinColor) {
          hoverIcon = icon.cloneNode(true);
          hoverIcon.querySelector('path').setAttribute(
          'fill', hoverPinColor);

          icons.HOVER = hoverIcon.innerHTML;
        }
      }

      self.map = new BingMap(
        mapContainer, self.opts.credentials, self.opts.options);

      if (!self.map.isLoaded()) {
        self.map.load();
      } else {
        self.map.create();
        attachSearchArea();
        self.map.updatePins(self.opts.points || []);
      }

      window.addEventListener('resize', debouncedResize);
    });

    window.addEventListener('bingmapsloaded', function() {
      self.map.create();
      attachSearchArea();
      self.map.updatePins(dealers || self.opts.points || [], null, icons);

      self.map.nodeElement.removeAttribute('style');

      if (self.opts.points && (self.opts.points.length > 0 ||
        dealers > 0)) {

        self.update();
      }
    });

    window.addEventListener('bingmapspinselected', function(e) {
      self.bus.trigger(self.bus.EVENTS.DEALERS.SELECT,
        {
          index: e.detail.index
        }
      );

      if (window._satellite) {
        window._satellite.setVar('dealerName', dealers[e.detail.index].Name);
        window._satellite.track('dealerMapPin');
      }
    });

    window.addEventListener('searcharea', function() {
      self.bus.trigger(self.bus.EVENTS.DEALERS.SEARCH, {
        lat: self.map.map.getBounds().center.latitude,
        long: self.map.map.getBounds().center.longitude,
        maxResults: parseInt(self.labels.zipCodeMaxResults, 10) || Infinity
      });
    });

    this.bus.on(this.bus.EVENTS.DEALERS.DATA_LOADED, updatePins);
    this.bus.on(this.bus.EVENTS.DEALERS.SELECT, selectDealer);
    this.bus.on(this.bus.EVENTS.DEALERS.RESET_ORIGIN, resetOrigin);
    this.bus.on(this.bus.EVENTS.DEALERS.SET_ORIGIN, setOrigin);
    this.bus.on(this.bus.EVENTS.DEALERS.OPEN_DETAIL, function(data) {
      var mapContainer = self.root.querySelector('.map-container');
      self.onDetailView = true;
      selectDealer(data, 'open');

      if (mapContainer.classList.contains('fixed')) {
        mapContainer.classList.remove('fixed');
      }
      self.map.closeInfobox();
    });
    this.bus.on(this.bus.EVENTS.DEALERS.CLOSE_DETAIL, function(data) {
      var mapContainer = self.root.querySelector('.map-container');
      self.onDetailView = false;
      selectDealer(data, 'close');

      if (mapContainer.classList.contains('fixed')) {
        mapContainer.classList.remove('fixed');
      }
      self.map.closeInfobox();
    });
    this.bus.on(this.bus.EVENTS.DEALERS.SET_PREFERRED, function(data) {
      selectDealer(data, 'set_preferred');
    });
});
